import React, { useState } from "react";
import {
  CURRENCY_EURO,
  parseAmount,
  parseEncasing,
  isDefined,
  displayTranslations,
  fullName,
  scrollHtmlElementIntoView,
  isInAClosingState,
  parseSubmissionListItemRejectionReason
} from "../../utils/utils";
import I18n from 'i18n.js.erb'
import LanguageFlag from "./LanguageFlag";
import ShowBlueprintImageFrontImage from "./ShowBlueprintImageFrontImage";
import Paginator from "./Paginator";
import IconTooltip from "./IconTooltip";
import GradingCertificate from "./GradingCertificate";



// Stati dell'ordine in cui gli articoli sono in casa di gradazione ma non hanno ancora un esito
const ITEMS_IN_PROCESSING_STATES = ['received', 'in_progress'];


export const ItemDetail = ({
  item,
  handleShowLargeImage,
  submissionList,
  setBlueprintImage2ShowLargeImage,
  setproductToShowGradingCertificate,
  setShowCertificate,
  isMiddleman
}) => {

  const blueprintImage = item.product?.blueprint_image;
  const blueprintImageNames = isDefined(blueprintImage) ? displayTranslations(blueprintImage.en_name, blueprintImage.meta_name, blueprintImage.language) : null;
  const blueprintImageFullName = fullName(blueprintImage?.en_name, blueprintImage?.meta_name, blueprintImage?.language)
  const entity = isDefined(blueprintImage) ? 'submission_list_item' : 'supplementary_item';
  const showItemResults = isInAClosingState(submissionList) || submissionList.show_gradings;
  const description = item.comes_from_supplementary_item ? item.comes_from_supplementary_item : (item.description ? item.description : I18n.t("js.common.noneFemale"));


  // Contenuto della riga "classificato come": esito del respingimento, nome dell'articolo
  // classificato oppure stato di classificazione in corso
  const renderClassifiedAs = () => {
    if (showItemResults && isDefined(item.rejected))
      return <p className="slx-value slx-value--big mb-0">
        <span className="slx-item-rejected">{I18n.t('js.common.submissionListState.rejected')}: </span>
        {parseSubmissionListItemRejectionReason(item.rejected)}
      </p>

    if (entity === 'submission_list_item')
      return <p className="slx-item-name text-truncate">
        <IconTooltip
          tooltipContent={blueprintImageFullName}
          customTxt={`${blueprintImageNames[0]} ${blueprintImage.collector_number ? blueprintImage.collector_number : ''}`}
        />
      </p>

    return <p className="slx-item-name">
      {I18n.t('js.editSubmissionListPage.inClassification').toUpperCase()}
    </p>
  }


  // Contenuto della colonna di destra: certificato/grade dell'articolo gradato
  // oppure stato di lavorazione corrente
  const renderStateColumn = () => {
    if (!showItemResults) {
      // gli articoli già classificati ma non ancora gradati restano "in grading", mentre quelli
      // ancora da classificare non hanno indicazione: lo stato è già nella riga "classificato come"
      if (ITEMS_IN_PROCESSING_STATES.includes(submissionList.state) && isDefined(blueprintImage))
        return <p className="slx-item__state-label">
          {I18n.t('js.myCollectionEditPage.productStateGrading')}
        </p>

      return null;
    }

    if (isDefined(item.rejected))
      return <img className="slx-item__rejected-mark" src={window.location.origin + '/images/icons/reject_r.svg'} alt="" />

    if (!item.grading)
      return null;

    if (item.product?.enable_grading_certificate)
      return (
        <button
          type="button"
          id={`aig-certificate_${item.id}`}
          className="slx-item__certificate cursor-pointer"
          onClick={(e) => {
            e.stopPropagation()
            setBlueprintImage2ShowLargeImage(blueprintImage)
            setproductToShowGradingCertificate(item)
            setShowCertificate(true)
          }}
        >
          <img src={window.location.origin + `/images/icons/certificate_badge.svg`} alt="" />
          <span className="slx-pill">
            {I18n.t('js.showCertificateModal.certificate')}
          </span>
        </button>
      )

    // gradazione presente ma senza certificato emettibile (invalidata, superata da una
    // rigradazione, prodotto non ancora graded): nel Figma non è previsto nulla a destra
    return null;
  }


  return (
    <div className="slx-item" key={entity + '_' + item.id}>
      <div className="slx-item__media">
        {
          entity === 'submission_list_item' ?
            <ShowBlueprintImageFrontImage
              size={"thumb"}
              blueprintImage={blueprintImage}
              handleShowLargeImage={handleShowLargeImage}
              additionalClasses={item.is_graded_image ? (blueprintImage?.blueprint?.category?.name?.toLowerCase() === 'booster pack' ? "thumb-image-graded-booster-pack m-auto" : "thumb-image-graded-card m-auto") : ''}
            />
            :
            item.thumb_image_url ?
              <ShowBlueprintImageFrontImage
                size={"thumb"}
                blueprintImage={item}
                handleShowLargeImage={handleShowLargeImage}
                additionalClasses={"br-4px"}
              />
              :
              <img src={window.location.origin + `/images/placeholder/placeholder.svg`}
                alt=""
                height='100'
                width='70'
              />
        }
      </div>

      <div className="slx-item__body">
        <div className="slx-item__row">
          <p className="slx-label slx-label--medium">
            {I18n.t('js.editSubmissionListPage.myDescription').toUpperCase()}
          </p>
          <p className="slx-value slx-value--big text-truncate mb-0">
            <IconTooltip
              tooltipContent={description}
              customTxt={description}
            />
          </p>
        </div>

        <div className="slx-item__row slx-item__row--classification">
          <p className="slx-label slx-label--medium">
            {I18n.t('js.editSubmissionListPage.classifiedAs').toUpperCase()}
          </p>
          {renderClassifiedAs()}
        </div>

        <div className="slx-item__cells">
          <div className="slx-item__cell">
            <p className="slx-label slx-label--medium">
              {I18n.t('js.editSubmissionListPage.tableHeaderEncasing').toUpperCase()}
            </p>
            <p className="slx-value slx-value--big mb-0">
              {parseEncasing(item.encasing, blueprintImage ? blueprintImage.blueprint.category.name : item.category_name)}
            </p>
            <ConditionalSleeveEncasing
              item={item}
              cssClassList={'color-dark-orange text-wrap my-0 font-size-84perc'}
            />
          </div>

          <div className="slx-item__cell">
            <p className="slx-label slx-label--medium">
              {I18n.t('js.editSubmissionListPage.labelLanguage').toUpperCase()}
            </p>
            <div className="d-flex align-items-center">
              <LanguageFlag
                language={item.label_language}
                maxHeight={'20px'}
                cssClassList={'mb-0'}
                displayRoundFlag={true}
                displayLanTxt={true}
                displayLanTxtFirst={true}
              />
            </div>
          </div>

          <div className="slx-item__cell">
            <p className="slx-label slx-label--medium">
              {I18n.t('js.editSubmissionListPage.priceVatExcluded').toUpperCase()}
            </p>
            <div className="slx-value slx-value--big">
              <ItemPricing
                item={item}
                amountToRender={isMiddleman ? 'amount_vat_excluded' : 'customer_amount_vat_excluded'}
              />
            </div>
            <ConditionalGradingService
              item={item}
              cssClassList={'color-dark-orange text-wrap my-0 font-size-84perc'}
            />
          </div>
        </div>
      </div>

      <div className="slx-item__state">
        {renderStateColumn()}
      </div>
    </div>
  );
}


export const parseConditionalSleeveEncasing = (item) => {
  if (item.case_lower_limit)
    return I18n.t('js.editSubmissionListPage.webComponent.draft.sleeveIf') + ' ' + I18n.t('js.editSubmissionListPage.webComponent.draft.overallLessThenCompact') + item.case_lower_limit
  else
    return '';
}

export const ConditionalSleeveEncasing = ({
  item,
  cssClassList
}) => {

  return (
    item.case_lower_limit &&
    <p className={cssClassList ? cssClassList : "color-dark-orange text-wrap my-0 font-size-84perc"}>
      {parseConditionalSleeveEncasing(item)}
    </p>
  );
}


export const parseConditionalGradingService = (item, compact) => {
  if (item.grading_lower_limit)
    return I18n.t(`js.editSubmissionListPage.webComponent.draft.authenticateIf${compact ? 'Compact' : ''}`) + ' ' + I18n.t('js.editSubmissionListPage.webComponent.draft.overallLessThenCompact') + item.grading_lower_limit
  else
    return '';
}

export const ConditionalGradingService = ({
  item,
  cssClassList
}) => {

  return (
    item.grading_lower_limit &&
    <p className={cssClassList ? cssClassList : "color-dark-orange text-wrap my-0 font-size-84perc"}>
      {parseConditionalGradingService(item, true)}
    </p>
  );
}



export const ItemPricing = ({
  item,
  baseAmountToRender,
  amountToRender,
  showVatMessage
}) => {

  return (
    <React.Fragment>
      <div className="p-0 m-0">
        <p className="mb-0">
          {parseAmount(item[amountToRender], 2) + CURRENCY_EURO}
          {
            showVatMessage &&
            <React.Fragment>
              &nbsp;
              <span className="font-size-80perc">
                ({I18n.t(`js.editSubmissionListPage.webComponent.draft.vat${amountToRender.indexOf('vat_excluded') > -1 ? 'Ex' : 'In'}cluded`)})
              </span>
            </React.Fragment>
          }
        </p>

        {
          isDefined(item.fee) &&
          <p className="mb-0">
            <span
              className={`font-size-80perc color-dark-orange text-wrap mt-2`}>
              ({parseAmount(item[baseAmountToRender], 2)}{CURRENCY_EURO} + {item.fee}%&nbsp;<br />
              {I18n.t('js.editSubmissionListPage.onDeclaredValue')})
            </span>
          </p>
        }
      </div>
    </React.Fragment>
  );
}


const SubmissionListContent = ({
  submissionList,
  handleShowLargeImage,
  isMiddleman
}) => {

  const [items, setItems] = useState([...submissionList.submission_list_items, ...submissionList.supplementary_items])
  const [blueprintImage2ShowLargeImage, setBlueprintImage2ShowLargeImage] = useState(null);
  const [productToShowGradingCertificate, setproductToShowGradingCertificate] = useState(null);
  const [showCertificate, setShowCertificate] = useState(false);

  return (
    <div className="m-auto">
      {
        submissionList.items_count > 0 ?
          <div>
            <h2 className="slx-section-title">
              {I18n.t('js.editSubmissionListPage.myItemsTitle')}
            </h2>

            <div className="w-100 m-0 p-0" id="itemsTopList" />

            <div className="slx-items">
              {items.map((item, i) => {
                return (
                  <ItemDetail
                    key={(isDefined(item.product?.blueprint_image) ? 'submission_list_item_' : 'supplementary_item_') + item.id}
                    item={{ ...item }}
                    handleShowLargeImage={handleShowLargeImage}
                    submissionList={submissionList}
                    setBlueprintImage2ShowLargeImage={setBlueprintImage2ShowLargeImage}
                    setproductToShowGradingCertificate={setproductToShowGradingCertificate}
                    setShowCertificate={setShowCertificate}
                    isMiddleman={isMiddleman}
                  />
                )
              }
              )}
            </div>

            <Paginator
              itemsCount={submissionList.items_count}
              items={[...submissionList.submission_list_items, ...submissionList.supplementary_items]}
              setItems={setItems}
              // cambiando pagina si torna in cima alla lista: legato al click e non al cambio di
              // items, che il paginatore aggiorna gia' al primo render aprendo l'ordine a meta'
              onPageChange={() => scrollHtmlElementIntoView(document, 'itemsTopList', true)}
            />
          </div>
          :
          <div className="d-flex justify-content-center mt-5 pt-5">
            <div className="d-flex align-items-center">
              <p className="text-center text--size-18px text-weight-500">{I18n.t('js.editSubmissionListPage.noCardInSubmissionList')}</p>
            </div>
          </div>
      }

      <GradingCertificate
        originalGradingCertificate={productToShowGradingCertificate ? productToShowGradingCertificate.grading : ''}
        originalLabel={productToShowGradingCertificate ? productToShowGradingCertificate.current_label : ''}
        originalBlueprintImage={blueprintImage2ShowLargeImage ? blueprintImage2ShowLargeImage : ''}
        showCertificate={showCertificate}
        setShowCertificate={setShowCertificate}
      />
    </div>
  );
};

export default SubmissionListContent;
